import DirectusSDK from "@directus/sdk-js";
import { DIRECTUS_PROJECT, DIRECTUS_SERVER } from "./config";
import {
  ArticleItem,
  AttributesItem,
  CategoryItem,
  FeatureItem,
  InstallationItem,
  StageItem,
  SupportItem
} from "./global/types";

const client = new DirectusSDK({
  url: DIRECTUS_SERVER,
  project: DIRECTUS_PROJECT,
  // @ts-ignore
  storage: window.localStorage
});

const defaultFields = ["created_on", "id", "status"];

/**
 * get collection article from directus
 * @returns {Array} Article Items
 */

export const getArticles = async () => {
  const data = await client.getItems<ArticleItem[]>("articles", {
    fields: [
      ...defaultFields,
      "featured_faq",
      "article_content",
      "subtitle",
      "category.id",
      "category.title",
      "title",
      "pdfs.directus_files_id",      
    ]
  });
  return data;
};

/**
 * get pdf files from directus
 * @returns {Array} pdf files
 */

export const getPdfs = async () => {
  const data = await client.getFiles({
    filter: {
      type: {
        eq: "application/pdf"
      }
    },
    fields: [
      "id",
      "title",
      "filename_download",
      "filesize",
      "data.asset_url"
    ]
  });
  return data;
};

/**
 * get collection stage from directus
 * @returns {Array} Stage Items
 */

export const getStage = async () => {
  const data = await client.getItems<StageItem[]>("stage", {
    fields: [
      ...defaultFields,
      "description_text",
      "headline_text",
      "image.data.asset_url",
      "linked_article.id",
      "image.title"
    ]
  });
  return data;
};

/**
 * get collection category from directus
 * @returns {Array} Category Items
 */

export const getCategories = async () => {
  const data = await client.getItems<CategoryItem[]>("category");
  return data;
};

/**
 * get collection installation from directus
 * @returns {Array} Installation Items
 */

export const getInstallation = async () => {
  const data = await client.getItems<InstallationItem[]>("installation");
  return data;
};

/**
 * get collection features from directus
 * @returns {Array} Feature Items
 */

export const getFeatures = async () => {
  const data = await client.getItems<FeatureItem[]>("features", {
    fields: [
      ...defaultFields,
      "feature_1_headline",
      "feature_1_icon.data.asset_url",
      "feature_1_link",
      "feature_1_text",
      "feature_2_headline",
      "feature_2_icon.data.asset_url",
      "feature_2_link",
      "feature_2_text",
      "headline_features"
    ]
  });
  return data;
};

/**
 * get collection attributes from directus
 * @returns {Array} Attribute Items
 */

export const getAttributes = async () => {
  const data = await client.getItems<AttributesItem[]>("attributes");
  return data;
};

/**
 * get collection Support from directus
 * @returns {Array} Support Items
 */

export const getSupport = async () => {
  const data = await client.getItems<SupportItem[]>("support");
  return data;
};